export default "__VITE_ASSET__BY$IIBN1__"